import React, { useContext, useMemo, useRef, useState } from "react";
import CommonContext from "../Context/context";
import { helperText, uploadFile } from "../Helper/helperFunctions";
import ReactHtmlParser from "react-html-parser";
import { toast } from "react-toastify";
import { postAdmission } from "../Service/ApiFunction";
const emptyData = {
  fullName: "",
  dateOfBirth: "",
  gender: "",
  religion: "",
  city: "",
  state: "",
  country: "",
  guardianName: "",
  relation: "",
  contactNumber: "",
  address: "",
  pincode: "",
  course: "",
  profileImage: "",
  nationality: "",
};
const Admission = () => {
  const admissionRef = useRef();
  const { cmsData } = useContext(CommonContext);
  const [admissionData, setAdmissionData] = useState(emptyData);
  const [loader, setLoader] = useState(false);
  const AdmissionAbout = cmsData?.find(
    (ele) => ele?.heading == "Admission-Form About"
  )?.description;

  const fillAdmissionData = (name, value) => {
    setAdmissionData((old) => {
      return { ...old, [name]: value };
    });
  };

  const uploadJpgFile = async (e) => {
    setLoader(true);
    const type = "profileImage";
    const res = await uploadFile(e, setAdmissionData.fullName, type);
    setAdmissionData((old) => ({ ...old, profileImage: res }));
    setLoader(false);
  };

  const submitAdmissionData = async (e) => {
    setLoader(true);
    const {
      fullName,
      dateOfBirth,
      gender,
      religion,
      city,
      state,
      country,
      guardianName,
      relation,
      contactNumber,
      address,
      pincode,
      course,
      profileImage,
      nationality,
    } = admissionData;
    e.preventDefault();
    if (
      fullName == "" ||
      dateOfBirth == "" ||
      gender == "" ||
      religion == "" ||
      city == "" ||
      state == "" ||
      country == "" ||
      guardianName == "" ||
      relation == "" ||
      contactNumber == "" ||
      address == "" ||
      pincode == "" ||
      course == "" ||
      profileImage == "" ||
      nationality == ""
    ) {
      toast.error("Please Fill All The Fields");
      setLoader(false);
      return;
    }
    try {
      const responseSubmit = await postAdmission(admissionData);
      if (responseSubmit?.ack == 1) {
        toast.success("Submitted Successfully");
        setAdmissionData({ ...emptyData });
        admissionRef.current.value = "";
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };
  const gender = useMemo(() => ["Male", "Female", "Other"], []);

  return (
    <>
      <div className="career-bg" style={{ background: "#6c5ebf1c" }}>
        <div className="container">
          <div className="row">
            <div className="school-main-title">
              <div className="school-heading-subheading center-align text-center">
                <h2 className="school-title">Admission From</h2>
                <div className="school-heading-desc">
                  {AdmissionAbout?.includes("<p>") ||
                  AdmissionAbout?.includes("<h1>") ||
                  AdmissionAbout?.includes("<h2>") ||
                  AdmissionAbout?.includes("<h3>")
                    ? ReactHtmlParser(AdmissionAbout)
                    : AdmissionAbout
                    ? AdmissionAbout
                    : helperText.slice(0, 30)}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="sm-12">
              <div className="form-inner">
                <div className="row mb-3 g-3">
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Full Name"
                      name="fullName"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.fullName}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Date of Birth</label>
                    <input
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      type="date"
                      className="form-control"
                      placeholder="Enter Your Date of Birth"
                      name="dateOfBirth"
                      value={admissionData?.dateOfBirth}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Gender</label>
                    <select
                      className="form-control"
                      value={admissionData?.gender}
                      onChange={(e) => {
                        setAdmissionData((old) => {
                          return { ...old, gender: e.target.value };
                        });
                      }}
                    >
                      <option value="">Select...</option>
                      {gender?.map((ele) => {
                        return <option value={ele}>{ele}</option>;
                      })}
                    </select>
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Religion</label>
                    <input
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Religion"
                      name="religion"
                      value={admissionData?.religion}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">City</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your City"
                      name="city"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.city}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">State</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your State"
                      name="state"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.state}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Country</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Country"
                      name="country"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.country}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Guardian Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Guardian Name"
                      name="guardianName"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.guardianName}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Relation</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Relation"
                      name="relation"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.relation}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Contact Number</label>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control"
                      placeholder="Enter Your Contact Number"
                      name="contactNumber"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.contactNumber}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Address</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Address"
                      name="address"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.address}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Pin code</label>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control"
                      placeholder="Enter Your Pin code"
                      name="pincode"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.pincode}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">
                      Class For Which Admission Is Taken
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Course"
                      name="course"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.course}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Nationality</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Nationality"
                      name="nationality"
                      onChange={(e) => {
                        fillAdmissionData(e.target.name, e.target.value);
                      }}
                      value={admissionData?.nationality}
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Upload Your Photo</label>
                    <input
                      ref={admissionRef}
                      type="file"
                      className="form-control"
                      name="file"
                      accept="image/png, image/jpeg"
                      onChange={(e) => uploadJpgFile(e)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-12 text-center mt-4">
                    <button
                      disabled={loader}
                      className="theme-btn btn-style-one text-center"
                      type="submit"
                      onClick={(e) => submitAdmissionData(e)}
                    >
                      {loader ? (
                        <div class="spinner-border text-dark" role="status">
                          <span class="sr-only"></span>
                        </div>
                      ) : (
                        <>
                          <span>Submit</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admission;
